<template lang="pug">
  el-form(
    :model="form"
    ref="EditPasswordSettings"
    :rules="passwordFormRules"
    @submit.native.prevent
  )
    h3.mb-3.mt-5 {{ $t('settings.change_password') }}
    el-row.mt-3.responsive(:gutter="20")
      el-col(:span="15")
        el-form-item(
          prop="password"
          :label="$t('settings.password_form.new_password')"
        )
          el-input(
            v-model="form.password"
            :show-password="true"
            type="password"
            name="password"
          )
    el-row.mt-3.responsive(:gutter="20")
      el-col(:span="15")
        el-form-item(
          prop="password_confirmation"
          :label="$t('settings.password_form.confirm_password')"
        )
          el-input(
            v-model="form.password_confirmation"
            :show-password="true"
            type="password"
            name="password_confirmation"
          )
    el-row.mt-3.responsive(:gutter="20")
      el-button.dark-green-btn.mt-3.settings-btn(
        @click="handleUpdatePasswordSettings('EditPasswordSettings')"
        :loading="loading"
      ) {{ $t('settings.save') }}
</template>

<script>
import { mapActions, mapState } from "vuex";
import { settingsViewValidations } from "@/src/utils/formValidations/settingsViewValidations";
import { customValidations } from "@utils/customValidators";

export default {
  name: "ProfileChangeForm",
  mixins: [settingsViewValidations, customValidations],

  data() {
    return {
      form: {
        password: null,
        password_confirmation: null,
      },
      loading: false,
    };
  },

  computed: {
    ...mapState("auth", ["access_token", "user"]),
  },

  methods: {
    ...mapActions({
      changePassword: "user/changePassword",
      updateUserProfile: "auth/updateUserProfile",
      generateChangeEmailLink: "user/generateChangeEmailLink",
      updateProfile: "user/updateProfile",
      logout: 'auth/logout'
    }),

    handleUpdatePasswordSettings(formName) {
      this.loading = true;

      const form = this.$refs[formName];

      form.validate(async (valid) => {
        if (valid) {
          let payload = { ...this.form };

          this.changePassword(payload).finally(async () => {
            await this.logout()
            this.$store.commit('soilSensor/RESET_MODULE')
            this.$router.push('/login')
            this.loading = false;
          });
        } else {
          this.loading = false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@media only screen and (max-width: 600px) {
  .responsive {
    display: flex;
    flex-direction: column !important;
    overflow: scroll;

    .el-col {
      width: 100%;
    }
  }
}

.el-form {
  // padding: 0 60px;

  .el-form-item {
    margin-bottom: 0;
  }
}
</style>